import React, { useEffect, useState, useCallback } from "react";
import ItJustWorks from "../asset/itJustWorks.png";
import de from "../asset/de.jpg";
import zc from "../asset/zc.png";
import it from "../asset/it.jpg";
import en from "../asset/en.jpg";
import placeholder from "../asset/placeholder.png";
import logoWeiß from "../asset/logo_weiß.png";
import "../pages/Home.css";
import { height } from "@fortawesome/free-solid-svg-icons/faCircleXmark";
import { useLocation } from "react-router-dom";
const primary = "#22577a";
const secondary = "#c8e0f0";
const LanguageSelector = ({ SaveLanguage, currentLanguage }) => {
  const translations = {
    english: {
      selectLanguage: "Select Language",
    },
    german: {
      selectLanguage: "Sprache auswählen",
    },
    czech: {
      selectLanguage: "Vybrat jazyk",
    },
    italian: {
      selectLanguage: "Seleziona lingua",
    },
  };

  return (
    <div className="p-2 bg-secondary" style={{ borderRadius: "10px" }}>
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        <li className="nav-item dropdown">
          <a
            className="nav-link dropdown-toggle"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {translations[currentLanguage]
              ? translations[currentLanguage].selectLanguage
              : "Language not supported"}
          </a>
          <ul className="dropdown-menu">
            <li>
              <a
                className="dropdown-item"
                href="#"
                onClick={() => SaveLanguage("english")}
              >
                English
              </a>
            </li>
            <li>
              <a
                className="dropdown-item"
                href="#"
                onClick={() => SaveLanguage("german")}
              >
                German
              </a>
            </li>
            <li>
              <a
                className="dropdown-item"
                href="#"
                onClick={() => SaveLanguage("czech")}
              >
                Czech
              </a>
            </li>
            <li>
              <a
                className="dropdown-item"
                href="#"
                onClick={() => SaveLanguage("italian")}
              >
                Italian
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
};

const Content = ({ currentLanguage }) => {
  const content = {
    english: {
      translated: {
        whatIsTax: "What is the SME Taxonomy Tool",
        optional: "optional",
        register: "Register",
        howWork: "How does it work?",
        whatAreTaxTool:
          "What are the different steps of the SME Taxonomy Tool?",
        login: "Log In",
        devWith:
          "Developed within the CONFESS project funded by the EU commission",
        ourAim:
          "Our aim is to support SMEs in their sustainability reporting based on the EU Taxonomy:",
        reportTaxList: [
          "get an initial overviw of the taxonomy conformity of your activities",
          "familiarize with the requirements of the EU Taxonomy",
        ],
        additionalDetails:
          "In addition , the tool offers a detailed evaluation of your data and, if desired a review by our experts or independent third parties",
      },
      subHeading: "Enables your SME to report on their sustainable activities",
      listOfBenefit: [
        "simplified EU Taxonomy criteria",
        "Easy to understand",
        "3rd party verified",
      ],
      heading: "SME Taxonomy Tool",
      paragraphs: [
        "Our aim is to support (in particular smaller) companies in their sustainability reporting based on the EU Taxonomy.",
        "The EU Taxonomy provides a standardized framework for classifying environmentally sustainable economic activities and is intended to help direct capital flows into such sustainable economic activities.",
        "Our tool offers you the opportunity to get an initial overview of the taxonomy conformity of your activities, while at the same time familiarizing you with the requirements of the EU taxonomy. In addition, the tool offers a detailed evaluation of your data and, if desired, a review by our experts or independent third parties.",
        "If you are new to taxonomy reporting, we recommend starting with the self-assessment. You can upgrade to the other options at any time.",
      ],
      cards: [
        {
          title: "Self-Assessment",
          text: "Use the self-assessment to familiarize yourself with the requirements of the EU taxonomy for your economic activities and to get an initial overview of the potential taxonomy alignment of your activities.",
          btnClass: "btn-1",
          link: "/login",
        },
        {
          title: "Expert Check",
          text: "Our experts check your statements in the self-assessment and verify the taxonomy alignment of your activities based on additional documents you upload as proof of your statements.",
          btnClass: "btn-1",
          link: "/expert",
        },
        {
          title: "3rd Party Verification",
          text: "An independent third party checks your statements in the self-assessment and verifies the taxonomy alignment of your activities based on additional documents you upload as proof of your statements.",
          btnClass: "btn-1",
          link: "/third",
        },
      ],
      button: "Choose Option",
    },
    german: {
      translated: {
        whatIsTax: "What is the SME Taxonomy Tool",
        optional: "optional",
        register: "Register",
        howWork: "How does it work?",
        whatAreTaxTool:
          "What are the different steps of the SME Taxonomy Tool?",
        login: "Log In",
        devWith:
          "Developed within the CONFESS project funded by the EU commission",
        ourAim:
          "Our aim is to support SMEs in their sustainability reporting based on the EU Taxonomy:",
        reportTaxList: [
          "get an initial overviw of the taxonomy conformity of your activities",
          "familiarize with the requirements of the EU Taxonomy",
        ],
        additionalDetails:
          "In addition , the tool offers a detailed evaluation of your data and, if desired a review by our experts or independent third parties",
      },
      subHeading: "Enables your SME to report on their sustainable activities",
      listOfBenefit: [
        "simplified EU Taxonomy criteria",
        "Easy to understand",
        "3rd party verified",
      ],
      heading: "Willkommen beim EU-Datentool",
      paragraphs: [
        "Unser Ziel ist es, (insbesondere kleinere) Unternehmen bei ihrer Nachhaltigkeitsberichterstattung auf Basis der EU-Taxonomie zu unterstützen.",
        "Die EU-Taxonomie bietet einen standardisierten Rahmen für die Klassifizierung ökologisch nachhaltiger Wirtschaftsaktivitäten und soll dazu beitragen, Kapitalströme in solche nachhaltigen Wirtschaftsaktivitäten zu lenken.",
        "Unser Tool bietet Ihnen die Möglichkeit, sich einen ersten Überblick über die Taxonomiekonformität Ihrer Aktivitäten zu verschaffen und sich gleichzeitig mit den Anforderungen der EU-Taxonomie vertraut zu machen. Darüber hinaus bietet das Tool eine detaillierte Auswertung Ihrer Daten und auf Wunsch eine Überprüfung durch unsere Experten oder eine unabhängige Zertifizierungsstelle.",
        "Wenn Sie neu in der Taxonomie-Berichterstattung sind, empfehlen wir, mit der Selbstbewertung zu beginnen. Sie können jederzeit auf die anderen Optionen upgraden.",
      ],
      cards: [
        {
          title: "Self-Assessment",
          text: "Nutzen Sie das Self-Assessment, um sich mit den Anforderungen der EU-Taxonomie für Ihre Wirtschaftsaktivitäten vertraut zu machen und sich einen ersten Überblick über die mögliche Taxonomieausrichtung Ihrer Aktivitäten zu verschaffen.",
          btnClass: "btn-1",
          link: "/login",
        },
        {
          title: "Expertencheck",
          text: "Unsere Experten prüfen Ihre Aussagen im Self-Assessment und verifizieren die Taxonomie-Ausrichtung Ihrer Aktivitäten anhand zusätzlicher Dokumente, die Sie als Nachweis Ihrer Aussagen hochladen.",
          btnClass: "btn-5",
          link: "#",
        },
        {
          title: "Verifizierung durch unabhängige Zertifizierungsstelle",
          text: "Eine unabhängige Zertifizierungsstelle prüft Ihre Aussagen im Self-Assessment und verifiziert die Taxonomie-Ausrichtung Ihrer Aktivitäten anhand zusätzlicher Dokumente, die Sie als Nachweis Ihrer Aussagen hochladen.",
          btnClass: "btn-5",
          link: "#",
        },
      ],
      button: "Auswählen",
    },
    czech: {
      translated: {
        whatIsTax: "Nástroj pro taxonomii MSP",
        optional: "optional",
        register: "Registrace",
        howWork: "Jak to funguje?",
        whatAreTaxTool:
          "Co je nástroj pro taxonomii MSP?",
        login: "Přihlášení",
        devWith:
          "Vyvinuto projektem CONFESS Financováno Evropskou komisí",
        ourAim:
          "Naším cílem je podpořit MSP v jejich reportování o udržitelnosti na základě EU Taxonomie:",
        reportTaxList: [
          "získat počáteční přehled o shodě vašich aktivit s taxonomií",
          "seznámit se s požadavky EU Taxonomie",
        ],
        additionalDetails:
          "Navíc nástroj nabízí podrobnou evaluaci vašich dat a, pokud si přejete, kontrolu našimi odborníky nebo nezávislými třetími stranami.",
      },
      subHeading: "Umožňuje vašemu MSP reportovat o udržitelných aktivitách",
      listOfBenefit: [
        "Zjednodušená kritéria EU Taxonomie",
        "Snadno pochopitelné",
        "Ověřeno třetí stranou",
      ],
      heading: "Vítejte v nástroji EU Data",
      paragraphs: [
        "Naším cílem je podporovat (zejména menší) společnosti v jejich zprávách o udržitelnosti na základě EU Taxonomie.",
        "EU Taxonomie poskytuje standardizovaný rámec pro klasifikaci ekologicky udržitelných ekonomických činností a má pomoci nasměrovat kapitálové toky do těchto udržitelných ekonomických činností.",
        "Náš nástroj vám nabízí možnost získat první přehled o shodě vašich aktivit s taxonomií a zároveň se seznámit s požadavky EU Taxonomie. Kromě toho nástroj nabízí podrobnou evaluaci vašich dat a, pokud si přejete, revizi našimi odborníky nebo nezávislými třetími stranami.",
        "Pokud jste noví v reportování podle taxonomie, doporučujeme začít s vlastními hodnocením. Kdykoli můžete přejít na jiné možnosti.",
      ],
      cards: [
        {
          title: "Sebehodnocení",
          text: "Použijte sebehodnocení k seznámení se s požadavky EU taxonomie pro vaše ekonomické aktivity a k získání počátečního přehledu o potenciální shodě vašich aktivit s taxonomií.",
          btnClass: "btn-1",
          link: "/login",
        },
        {
          title: "Odborná kontrola (volitelná) ",
          text: "Naši odborníci zkontrolují vaše prohlášení v sebehodnocení a ověří shodu vašich aktivit s taxonomií na základě dodatečných dokumentů, které nahrajete jako důkaz vašich prohlášení.",
          btnClass: "btn-5",
          link: "#",
        },
        {
          title: "3.  Ověření třetí stranou (volitelné)",
          text: "Nezávislá třetí strana zkontroluje vaše prohlášení v sebehodnocení a ověří shodu vašich aktivit s taxonomií na základě dodatečných dokumentů, které nahrajete jako důkaz vašich prohlášení.",
          btnClass: "btn-5",
          link: "#",
        },
      ],
      button: "Výběr aktivit",
    },
    italian: {
      translated: {
        whatIsTax: "Che cos'è lo SME taxonomy tool per le PMI",
        optional: "optional",
        register: "Register",
        howWork: "Come funziona?",
        whatAreTaxTool:
          "Quali sono le diverse fasi del SME Taxonomy Tool per le PMI?",
        login: "Log In",
        devWith:
          "Inoltre, lo strumento offre una valutazione dettagliata dei tuoi dati e, se desiderato, una revisione da parte dei nostri esperti o di terze parti indipendenti",
        ourAim:
          "Il nostro obiettivo è supportare le PMI nella rendicontazione della sostenibilità basata sulla Tassonomia UE:",
        reportTaxList: [
          "Ottenere una prima panoramica sulla conformità delle proprie attività alla Tassonomia",
          "Familiarizzare con i requisiti della Tassonomia UE",
        ],
        additionalDetails:
          "Sviluppato nell'ambito del progetto CONFESS finanziato dalla Commissione Europea",
      },
      subHeading: "Permette alla tua PMI di riportare le proprie attività sostenibili",
      listOfBenefit: [
        "Criteri semplificati della Tassonomia UE",
        "Facile da comprendere",
        "Verificato da terze parti",
      ],
      heading: "Benvenuti nel UE Data Tool",
      paragraphs: [
        "Il nostro obiettivo è quello di supportare le aziende(in particolare quelle piccole) nella loro rendicontazione di sostenibilità basata sulla Tassonomia UE.",
        "La Tassonomia UE fornisce un quadro standardizzato per classificare le attività economiche ambientalmente sostenibili e ha lo scopo di indirizzare i flussi di capitale verso tali attività economiche sostenibili.",
        "Il nostro strumento ti offre l’opportunità di ottenere una panoramica iniziale della conformità delle tue attività alla tassonomia, aiutandoti al contempo a familiarizzare con i requisiti della tassonomia UE. Inoltre, lo strumento offre una valutazione dettagliata dei tuoi dati e, se desiderato, una revisione da parte dei nostri esperti o di terze parti indipendenti.",
        "Se questo è il tuo primo approccio alla rendicontazione secondo la tassonomia, ti consigliamo di iniziare con l’auto-valutazione. Puoi scegliere di passare alle altre opzioni in qualsiasi momento.",
      ],
      cards: [
        {
          title: "Auto-Valutazione",
          text: "Utilizza l’auto-valutazione per familiarizzare con i requisiti della tassonomia UE per le tue attività economiche e ottenere una panoramica iniziale del potenziale allineamento alla tassonomia delle tue attività.",
          btnClass: "btn-1",
          link: "/login",
        },
        {
          title: "Controllo dell’Esperto",
          text: "I nostri esperti controllano le tue dichiarazioni fornite nell’auto-valutazione e verificano l’allineamento alla tassonomia delle tue attività basandosi su documenti aggiuntivi che carichi come prova delle tue dichiarazioni.",
          btnClass: "btn-5",
          link: "#",
        },
        {
          title: "Verifica di Terza Parte",
          text: "Una terza parte indipendente controlla le tue dichiarazioni fornite nell’auto-valutazione e verifica l’allineamento alla tassonomia delle tue attività basandosi su documenti aggiuntivi che carichi come prova delle tue dichiarazioni.",
          btnClass: "btn-5",
          link: "#",
        },
      ],
      button: "Scegli Opzione",
    },
  };

  const { heading, paragraphs, cards, subHeading, listOfBenefit, translated } =
    content[currentLanguage];

  return (
    <>
      <h1
        className="mt-3"
        style={{ textAlign: "left", fontSize: "50px", fontWeight: "700" }}
      >
        {heading}
      </h1>
      <h2
        style={{ textAlign: "left", fontSize: "30px", fontWeight: "500" }}
        className="mt-4"
      >
        {subHeading}
      </h2>
      <div className="d-flex mt-4">
        <div style={{ width: "50%" }}>
          {listOfBenefit.map((benefit, index) => (
            <div
              className="d-flex"
              style={{
                marginLeft: "100px",
                gap: "16px",
                marginBottom: "8px",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  height: "6px",
                  width: "6px",
                  background: "black",
                  borderRadius: "999px",
                }}
              ></div>
              <div> {benefit}</div>
            </div>
          ))}

          <div className="d-flex" style={{ gap: "40px", marginTop: "100px" }}>
            <div
              onClick={() => {
                window.location.replace("/signup");
              }}
              style={{
                width: "50%",
                background: "#22577a",
                borderRadius: "8px",
                cursor: "pointer",
                padding: "10px",
                color: "white",
                fontSize: "18px",
                boxShadow: "black 4px 4px 10px 0px ",
              }}
            >
              {translated.register}
            </div>
            <div
              onClick={() => {
                window.location.replace("/login");
              }}
              style={{
                width: "50%",
                background: secondary,
                borderRadius: "8px",
                padding: "10px",
                color: "white",
                fontSize: "18px",
                cursor: "pointer",
                boxShadow: "black 4px 4px 10px 0px ",
              }}
            >
              {translated.login}
            </div>
          </div>
          <div
            style={{ marginTop: "100px", width: "320px", textAlign: "left" }}
          >
            {translated.devWith}
          </div>
        </div>
        <div style={{ width: "50%" }}>
          <img src={placeholder} alt="placeholder"></img>{" "}
        </div>
      </div>

      <div
        style={{
          textAlign: "left",
          color: primary,
          fontSize: "30px",
          fontWeight: "600",
          marginTop: "24px",
        }}
      >
        {translated.whatIsTax}
      </div>

      <div
        style={{
          textAlign: "left",
          marginTop: "24px",
          marginBottom: "16px",
        }}
      >
        {translated.ourAim}
      </div>
      {translated.reportTaxList.map((report, index) => (
        <div
          className="d-flex"
          style={{
            marginLeft: "100px",
            gap: "16px",
            marginBottom: "8px",
            alignItems: "center",
          }}
        >
          <div
            style={{
              height: "6px",
              width: "6px",
              background: "black",
              borderRadius: "999px",
            }}
          ></div>
          <div> {report}</div>
        </div>
      ))}
      <div
        style={{
          textAlign: "left",
          marginTop: "24px",
        }}
      >
        {translated.additionalDetails}
      </div>

      {/* <div className="text-start mt-5">
        {paragraphs.map((p, index) => (
          <p key={index}>{p}</p>
        ))}
      </div> */}

      <div
        className="d-flex"
        style={{ marginTop: "120px", gap: "40px", alignItems: "center" }}
      >
        <div
          style={{
            marginLeft: "auto",
            textAlign: "left",
            color: primary,
            fontSize: "30px",
            fontWeight: "700",
            marginTop: "24px",
          }}
        >
          {translated.howWork}
        </div>
        <img src={ItJustWorks} alt="OnlineDataTool"></img>
      </div>

      <div style={{ fontSize: "30px", marginTop: "40px", fontWeight: "700" }}>
        {translated.whatAreTaxTool}
      </div>

      <div
        className="mt-5 d-flex justify-content-center"
        style={{ gap: "100px", marginBottom: "250px" }}
      >
        {cards.map((card, index) => (
          <div style={{ position: "relative" }}>
            <div
              style={{
                position: "absolute",
                width: "75px",
                height: "75px",
                left: "-20px",
                top: "10px",
                background: "#32a774",
                display: "flex",
                alignItems: "center",
                placeContent: "center",
                color: "white",
                fontSize: "24px",
                borderRadius: "9999px",
              }}
            >
              {index + 1}
            </div>
            <div style={{ opacity: index > 0 ? 1 : 0, marginBottom: "8px" }}>
              {translated.optional}
            </div>
            <div
              key={index}
              style={{
                background: index > 0 ? "rgba(34, 87, 122, 0.65)" : "#22577a",
                borderRadius: "50px",
                padding: "20px",
                border: "2px solid " + primary,
              }}
            >
              <div className="card-body d-flex flex-column justify-content-between align-items-center">
                <h5 className="card-title fs-5 text-start text-white">
                  {card.title}
                </h5>
                <p className="card-text mt-4 text-start">{card.text}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

function Home() {
  const [currentLanguage, setCurrentLanguage] = useState(
    localStorage.getItem("language") || "english"
  );

  const location = useLocation();
  const confirmed = new URLSearchParams(location.search).get('confirmed');
  if(confirmed) {
    alert("Account confirmed! You will receive an email once an administrator has activated your account and it is ready for login.");
  }

  const SaveLanguage = useCallback(
    (language) => {
      if (currentLanguage !== language) {
        localStorage.setItem("language", language);
        setCurrentLanguage(language); // Update the state
      }
    },
    [currentLanguage]
  );

  useEffect(() => {
    if (!localStorage.getItem("language")) {
      localStorage.setItem("language", "english");
      setCurrentLanguage("english");
    }
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <div className="">
        <div
          className="d-flex justify-content-around"
          style={{ height: "70px", background: "#282c34" }}
        >
          <div
            style={{
              textAlign: "center",
              fontSize: "24px",
              marginLeft: "120px",
            }}
            className="text-white"
          >
            <div>
            <img src={logoWeiß} alt='logo' width={350} /></div>
            
          </div>
          <div
            className="d-flex"
            style={{ alignItems: "center", gap: "60px", marginLeft: "120px" }}
          >
            <div className="d-flex gap-4">
              <img
                onClick={() => {
                  SaveLanguage("czech");
                }}
                style={{ height: "25px", cursor: "pointer" }}
                src={zc}
                alt="zc"
              />
              <img
                onClick={() => {
                  SaveLanguage("german");
                }}
                style={{ height: "25px", cursor: "pointer" }}
                src={de}
                alt="de"
              />
              <img
                onClick={() => {
                  SaveLanguage("italian");
                }}
                style={{ height: "25px", cursor: "pointer" }}
                src={it}
                alt="it"
              />
              <img
                onClick={() => {
                  SaveLanguage("english");
                }}
                style={{ height: "25px", cursor: "pointer" }}
                src={en}
                alt="en"
              />
            </div>{" "}
            {/* <LanguageSelector
              SaveLanguage={SaveLanguage}
              currentLanguage={currentLanguage}
            /> */}
            <div
              className="p-2 d-flex"
              style={{ borderRadius: "10px", alignItems: "center", gap: "8px" }}
            >
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Log In
                    {/* {translations[currentLanguage]
                      ? translations[currentLanguage].selectLanguage
                      : "Language not supported"} */}
                  </a>
                  <ul className="dropdown-menu forceUlColor">
                    <li>
                      <a
                        className="dropdown-item"
                        style={{ color: "white" }}
                        href="/login"
                      >
                        Log In
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        style={{ color: "white" }}
                        href="/third"
                      >
                        Expert/3rd party
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div style={{ paddingLeft: "100px", paddingRight: "100px" }}>
          <Content currentLanguage={currentLanguage} />
        </div>
      </div>
    </div>
  );
}

export default Home;
